import React, { useEffect, useState } from "react";
import Icon from "./ui/Icon";
import EmptyState from "./ui/EmptyState";
import "../styles/AdminReport.css";
// SM-AUTH-HR: login token for the fetch calls below. REVERT: delete this
// import and the ...authHeader() entries.
import { authHeader } from "./axios";

const AdminReport = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        search: "",
        business: "",
        manager: ""
    });

    const fetchData = async () => {
        setLoading(true);
        // SM-AUTH-HR: send the login token. REVERT: back to
        //   const res = await fetch("/api/reports/get-skill-report");
        // and delete the !res.ok check (it stops the spinner hanging on 401).
        const res = await fetch("/api/reports/get-skill-report", { headers: authHeader() });
        if (!res.ok) {
            setLoading(false);
            return;
        }
        const result = await res.json();
        setData(result);
        setFilteredData(result);
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        let temp = [...data];

        if (filters.search) {
            const search = filters.search.toLowerCase();
            temp = temp.filter(item =>
                Object.values(item).some(val =>
                    val && val.toString().toLowerCase().includes(search)
                )
            );
        }

        if (filters.business) {
            temp = temp.filter(item => item.businessType === filters.business);
        }

        if (filters.manager) {
            temp = temp.filter(item => item.managerName === filters.manager);
        }

        setFilteredData(temp);
    }, [filters, data]);


    const exportToExcel = async () => {
        try {
            const response = await fetch("/api/reports/download-skill-report", {
                method: "POST",
                // SM-AUTH-HR: ...authHeader() added. REVERT: delete it.
                headers: { "Content-Type": "application/json", ...authHeader() },
                body: JSON.stringify(filteredData)
            });

            if (!response.ok) throw new Error("Download failed");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "FilteredReport.xlsx";

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {
            //    if (process.env.NODE_ENV !== "production") {
            //        console.error("Error fetching manager review:", error);
            //    }

            //alert("Download failed");
        }
    };
    const exportUnmatchedSkills = async () => {
        try {
            const response = await fetch(
                "/api/EmployeeSkill/download-unmatched-skills",
                {
                    method: "GET",
                    // SM-AUTH-HR: send the login token. REVERT: delete this line.
                    headers: authHeader()
                }
            );

            if (!response.ok) throw new Error("Download failed");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "UnmatchedSkills.xlsx";

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {
            //console.error(err);
            //alert("Download failed");
        }
    };
    const unique = key => [...new Set(data.map(x => x[key]).filter(Boolean))];

    return (
        <div className="report-page">
            <header className="page-head reveal">
                <span className="page-eyebrow">Reports</span>
                <h1 className="page-title-mt">Employee Skill Report</h1>
                <p className="page-sub">
                    Organisation-wide skill submissions, filterable and exportable.
                </p>
            </header>

            {/* FILTER BAR */}
            <div className="card-mt card-pad filter-bar reveal reveal-d1">
                <div className="filter-group filter-group-search">
                    <label htmlFor="searchReport" className="field-label">Search</label>
                    <div className="report-search-wrap">
                        <Icon name="search" size={16} className="report-search-icon" />
                        <input
                            id="searchReport"
                            type="text"
                            className="input-mt report-search-input"
                            placeholder="Search anything…"
                            value={filters.search}
                            onChange={e =>
                                setFilters({ ...filters, search: e.target.value })
                            }
                        />
                    </div>
                </div>

                <div className="filter-group">
                    <label htmlFor="businessFilter" className="field-label">Business</label>
                    <select
                        id="businessFilter"
                        className="select-mt"
                        value={filters.business}
                        onChange={e =>
                            setFilters({ ...filters, business: e.target.value })
                        }
                    >
                        <option value="">All Business</option>
                        {unique("businessType").map((b, i) => (
                            <option key={i} value={b}>
                                {b}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="managerFilter" className="field-label">Manager</label>
                    <select
                        id="managerFilter"
                        className="select-mt"
                        value={filters.manager}
                        onChange={e =>
                            setFilters({ ...filters, manager: e.target.value })
                        }
                    >
                        <option value="">All Managers</option>
                        {unique("managerName").map((m, i) => (
                            <option key={i} value={m}>
                                {m}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="button-group">
                    <button
                        onClick={exportToExcel}
                        className="btn btn-primary-mt"
                        disabled={!filteredData.length}
                    >
                        <Icon name="download" size={16} />
                        Export Excel
                    </button>

                    <button
                        onClick={exportUnmatchedSkills}
                        className="btn btn-secondary-mt"
                    >
                        <Icon name="download" size={16} />
                        Unmatched Skills
                    </button>
                </div>
            </div>

            {/* TABLE */}
            <div className="card-mt report-table-card reveal reveal-d2">
                {loading ? (
                    <div className="report-skeleton" aria-hidden="true">
                        {[1, 2, 3, 4, 5, 6].map(i => (
                            <div key={i} className="skeleton" style={{ height: 22 }} />
                        ))}
                    </div>
                ) : filteredData.length > 0 ? (
                    <div className="table-wrap">
                        <table className="table-mt">
                            <thead>
                                <tr>
                                    <th scope="col">Emp ID</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Designation</th>
                                    <th scope="col">Manager</th>
                                    <th scope="col">Business</th>
                                    <th scope="col">Primary Skill</th>
                                    <th scope="col">Prev Exp</th>
                                    <th scope="col">Mindteck Exp</th>
                                    <th scope="col">Total Exp</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Reviewed On</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, i) => (
                                    <tr key={item.employeeId || i}>
                                        <td className="num">{item.employeeId}</td>
                                        <td className="report-emp-name">{item.employeeName}</td>
                                        <td>{item.designation}</td>
                                        <td>{item.managerName}</td>
                                        <td>{item.businessType}</td>
                                        <td>{item.primarySkill1}</td>
                                        <td className="num">{item.previousExperience}</td>
                                        <td className="num">{item.mindteckExperience}</td>
                                        <td className="num">{item.totalExperience}</td>
                                        <td>
                                            {item.submissionStatus === "Submitted" ? (
                                                <span className="badge-mt badge-success">
                                                    <Icon name="check" size={12} />
                                                    Submitted
                                                </span>
                                            ) : (
                                                <span className="badge-mt badge-warning">
                                                    <Icon name="clock" size={12} />
                                                    {item.submissionStatus}
                                                </span>
                                            )}
                                        </td>
                                        <td className="num">
                                            {item.reviewedOn
                                                ? new Date(item.reviewedOn).toLocaleDateString()
                                                : "—"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <EmptyState
                        icon="report"
                        title="No records found"
                        text="No employees match the current filters. Adjust the search or filters above."
                    />
                )}
            </div>
        </div>
    );
};

export default AdminReport;
